import React from 'react';
import styles from './Tabs.module.scss';

export interface TabItem {
    id: string;
    title: string | React.ReactElement;
    content?: React.ReactElement;
}

export interface TabGroup {
    id: string;
    tabs: TabItem[];
}

type Props = {
    items?: TabItem[];
    groups?: TabGroup[];
    activeTabId: string;
    onChange: (tabId: string) => void;
    emptyTabMessage?: string;
    compact?: boolean;
}

const Tabs = ({ items, groups, activeTabId, onChange, emptyTabMessage, compact }: Props) => {
    const allItems = groups
        ? groups.flatMap(g => g.tabs)
        : items || [];

    const activeTab = allItems.find(x => x.id === activeTabId);

    const renderTabItem = (item: TabItem) => (
        <div
            key={`tab-${item.id}`}
            onClick={() => { onChange(item.id); }}
            className={`${styles.listItem} ${activeTabId === item.id && styles.listItemActive}`}
        >
            {item.title}
        </div>
    );

    return (
        <div className={styles.container}>
            {groups ? (
                <div className={styles.tabGroups}>
                    {groups.map(group => (
                        <div key={group.id} className={styles.tabGroup}>
                            {group.tabs.map(renderTabItem)}
                        </div>
                    ))}
                </div>
            ) : (
                <div className={`${styles.list} ${compact ? styles.listCompact : ''}`}>
                    {(items || []).map(renderTabItem)}
                </div>
            )}
            {Boolean(activeTab) ? <div key={`tab-content-${activeTab!.id}`} className={styles.content}>
                {activeTab!.content}
            </div>
                :
                emptyTabMessage && <div key={`tab-content-empty`} className={styles.content}>
                    <div className={styles.message}>{emptyTabMessage}</div>
                </div>
            }

        </div>
    );
};

export default Tabs;
